module.exports = __webpack_public_path__ + "img/img-138.4d4602f1.png";